// Fetch all parking lots
export const FETCH_PARKING_LOTS = 'FETCH_PARKING_LOTS';
export const FETCH_PARKING_LOTS_SUCCESS = 'FETCH_PARKING_LOTS_SUCCESS';
export const FETCH_PARKING_LOTS_ERROR = 'FETCH_PARKING_LOTS_ERROR';

// Fetch parking lot by ID
export const FETCH_PARKING_LOT_BY_ID = 'FETCH_PARKING_LOT_BY_ID';
export const FETCH_PARKING_LOT_BY_ID_SUCCESS = 'FETCH_PARKING_LOT_BY_ID_SUCCESS';
export const FETCH_PARKING_LOT_BY_ID_ERROR = 'FETCH_PARKING_LOT_BY_ID_ERROR';

// Create parking lot
export const CREATE_PARKING_LOT = 'CREATE_PARKING_LOT';
export const CREATE_PARKING_LOT_SUCCESS = 'CREATE_PARKING_LOT_SUCCESS';
export const CREATE_PARKING_LOT_ERROR = 'CREATE_PARKING_LOT_ERROR';

// Update parking lot
export const UPDATE_PARKING_LOT = 'UPDATE_PARKING_LOT';
export const UPDATE_PARKING_LOT_SUCCESS = 'UPDATE_PARKING_LOT_SUCCESS';
export const UPDATE_PARKING_LOT_ERROR = 'UPDATE_PARKING_LOT_ERROR';

// Delete parking lot
export const DELETE_PARKING_LOT = 'DELETE_PARKING_LOT';
export const DELETE_PARKING_LOT_SUCCESS = 'DELETE_PARKING_LOT_SUCCESS';
export const DELETE_PARKING_LOT_ERROR = 'DELETE_PARKING_LOT_ERROR';

// Permit types
export const ADD_PERMIT_TYPE = 'ADD_PERMIT_TYPE';
export const ADD_PERMIT_TYPE_SUCCESS = 'ADD_PERMIT_TYPE_SUCCESS';
export const ADD_PERMIT_TYPE_ERROR = 'ADD_PERMIT_TYPE_ERROR';

export const UPDATE_PERMIT_TYPE = 'UPDATE_PERMIT_TYPE';
export const UPDATE_PERMIT_TYPE_SUCCESS = 'UPDATE_PERMIT_TYPE_SUCCESS';
export const UPDATE_PERMIT_TYPE_ERROR = 'UPDATE_PERMIT_TYPE_ERROR';

export const DELETE_PERMIT_TYPE = 'DELETE_PERMIT_TYPE';
export const DELETE_PERMIT_TYPE_SUCCESS = 'DELETE_PERMIT_TYPE_SUCCESS';
export const DELETE_PERMIT_TYPE_ERROR = 'DELETE_PERMIT_TYPE_ERROR';

// Zones
export const ADD_ZONE = 'ADD_ZONE';
export const ADD_ZONE_SUCCESS = 'ADD_ZONE_SUCCESS';
export const ADD_ZONE_ERROR = 'ADD_ZONE_ERROR';

export const UPDATE_ZONE = 'UPDATE_ZONE';
export const UPDATE_ZONE_SUCCESS = 'UPDATE_ZONE_SUCCESS';
export const UPDATE_ZONE_ERROR = 'UPDATE_ZONE_ERROR';

export const DELETE_ZONE = 'DELETE_ZONE';
export const DELETE_ZONE_SUCCESS = 'DELETE_ZONE_SUCCESS';
export const DELETE_ZONE_ERROR = 'DELETE_ZONE_ERROR';

// Zone permit type links
export const FETCH_ZONE_PERMIT_TYPES = 'FETCH_ZONE_PERMIT_TYPES';
export const FETCH_ZONE_PERMIT_TYPES_SUCCESS = 'FETCH_ZONE_PERMIT_TYPES_SUCCESS';
export const FETCH_ZONE_PERMIT_TYPES_ERROR = 'FETCH_ZONE_PERMIT_TYPES_ERROR';

export const LINK_PERMIT_TYPE_TO_ZONE = 'LINK_PERMIT_TYPE_TO_ZONE';
export const LINK_PERMIT_TYPE_TO_ZONE_SUCCESS = 'LINK_PERMIT_TYPE_TO_ZONE_SUCCESS';
export const LINK_PERMIT_TYPE_TO_ZONE_ERROR = 'LINK_PERMIT_TYPE_TO_ZONE_ERROR';

export const UPDATE_ZONE_PERMIT_TYPE_LINK = 'UPDATE_ZONE_PERMIT_TYPE_LINK';
export const UPDATE_ZONE_PERMIT_TYPE_LINK_SUCCESS = 'UPDATE_ZONE_PERMIT_TYPE_LINK_SUCCESS';
export const UPDATE_ZONE_PERMIT_TYPE_LINK_ERROR = 'UPDATE_ZONE_PERMIT_TYPE_LINK_ERROR';

export const UNLINK_PERMIT_TYPE_FROM_ZONE = 'UNLINK_PERMIT_TYPE_FROM_ZONE';
export const UNLINK_PERMIT_TYPE_FROM_ZONE_SUCCESS = 'UNLINK_PERMIT_TYPE_FROM_ZONE_SUCCESS';
export const UNLINK_PERMIT_TYPE_FROM_ZONE_ERROR = 'UNLINK_PERMIT_TYPE_FROM_ZONE_ERROR';

